import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

/**
 * GET `/dates/holidays` — 해당 연·월 공휴일 날짜 문자열 배열 (중복 제거).
 * `year`·`month`가 없으면 쿼리 비활성화.
 */
export function useHolidayDatesQuery(year?: number, month?: number) {
  const y = year ?? 0;
  const m = month ?? 0;

  return useQuery<string[]>({
    queryKey: QUERY_KEYS.dates.holidays(y, m),
    queryFn: async () => {
      const data = await httpClient.get<string[]>("/dates/holidays", {
        params: { year: y, month: m },
      });
      if (
        !Array.isArray(data) ||
        !data.every((item) => typeof item === "string")
      ) {
        throw new Error("휴일 정보를 가져오지 못했습니다.");
      }
      return [...new Set(data)];
    },
    enabled: !!year && !!month,
    staleTime: Infinity,
  });
}
